import React from 'react';
import { Header, Grid, Image, Card } from 'semantic-ui-react';

import BasicSectionLayout from './SectionLayout';
import SectionHeaderLayout from './SectionHeaderLayout';

// data 
import { DataOfContactCard, DataOfSponsors } from './data';


const Sponsor = ({ source, alt, href }) => {
  return (
    // eslint-disable-next-line
    <a href={href} target="_blank">
      <img src={source} alt={alt}  className="sponsor" />
    </a>
  );
}

const ContactCard = ({ nom, role, source }) => {
  return (
    <Grid.Column textAlign="center" stretched 
    computer={3} tablet={6} mobile={16} 
    className="flexIt"
    >
      <Card className="contactContact">
        <Image src={source} className="contactTof meTof"  />
        <Card.Content>
          <Card.Header> { nom } </Card.Header>
          <Card.Description>
            { role }
          </Card.Description>
        </Card.Content>
      </Card>
    
    </Grid.Column>
  )
}


const Contact = () => {
  return (
    <BasicSectionLayout fluide={true} sectionClasse="contactSection">

      <Grid.Column textAlign="center" computer={12} tablet={14} mobile={16}>
        <SectionHeaderLayout align="center" 
          headerclass="bigTitle"
          myhr={true}
          title="Contacts"
        >
          <p className="emailMe paragraph padded__text">
            For more informations about FIPI and its activities, please contact us at one
            of the addresses below
          </p>
        </SectionHeaderLayout>

        <div>
          <span className="contactInfos"> 
            <strong> Emails: </strong> <i> fipieducation@gmail.com / biawa.landry@gmail.com  </i> 
          </span>
        </div>

      </Grid.Column>

      <Grid.Row columns={3} className="contactSecondRow" textAlign="center">

        { DataOfContactCard.map((person, index) => {
          return (
              <ContactCard nom={person.nom}
                role={person.role}
                source={person.source}
                key={person.nom}
              />
            );
          })
        }

      </Grid.Row>

      <Grid.Row>

        <Grid.Column stretched  computer={12} tablet={14} mobile={10} 
          className="flexIt" textAlign="center" 
        >
          <Header as="h3" textAlign="center" className="titleSponsor"> Our sponsors </Header>

            <div className="allSponsors">
              { DataOfSponsors.map((sponsor, index) => {
                return (
                  <Sponsor alt={sponsor.alt}
                    source={sponsor.source}
                    href={sponsor.href}
                    key={`${sponsor.alt}${index}`}
                  />
                );
              })}
            </div>
        </Grid.Column>

      </Grid.Row>

    </BasicSectionLayout>
  );
}

export default Contact;